import React from "react"
import { Box, type BoxProps } from "@chakra-ui/layout"

export default function Highlight({ children, ...rest }: BoxProps) {
    return (
        <Box
            as="span"
            pos="relative"
            display="inline-block"
            px={1.5}
            pb={1}
            {...rest}
        >
            <Box
                position="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                bg="white"
                zIndex="0"
                borderRadius="sm"
            />
            <Box as="span" position="relative" zIndex="1" color="navy.700">
                {children}
            </Box>
        </Box>
    )
}
